import React, { useEffect, useMemo, useState } from 'react';

import { useBackgroundJob } from '../../hooks/backgroundjobs/useBackgroundJob';
import BackgroundJobsDrawer from './BackgroundJobsDrawer';
import Spinner from '../Spinners/Spinner';

const BackgroundJobRail: React.FC = () => {
  const [open, setOpen] = useState(false);

  const {
    jobs,
    refreshActiveJobs,
    startJobsPolling,
    stopJobsPolling,
  } = useBackgroundJob();

  const jobsCount = jobs.length;

  const hasRunningJobs = useMemo(
    () =>
      jobs.some(
        (job) =>
          job.status === 'PENDING' ||
          job.status === 'PROCESSING'
      ),
    [jobs]
  );

  useEffect(() => {
    void refreshActiveJobs();

    return () => {
      stopJobsPolling();
    };
  }, [refreshActiveJobs, stopJobsPolling]);

  useEffect(() => {
    if (hasRunningJobs) {
      startJobsPolling();
      return;
    }

    stopJobsPolling();
  }, [
    hasRunningJobs,
    startJobsPolling,
    stopJobsPolling,
  ]);

  if (jobsCount <= 0) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="
          fixed right-0 top-1/2 z-[9000]
          flex -translate-y-1/2 items-center gap-2

          rounded-l-lg border border-r-0 border-primary/30
          bg-white px-2.5 py-3
          shadow-default transition

          hover:bg-primary hover:text-white

          dark:border-primary/40
          dark:bg-boxdark
          dark:text-white
        "
        title="Tareas en segundo plano"
      >
        {hasRunningJobs && (
          <Spinner size={16} color="currentColor" />
        )}

        <span className="text-xs font-semibold">
          {jobsCount}
        </span>
      </button>

      <BackgroundJobsDrawer
        isOpen={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default BackgroundJobRail;